import {Button, Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC, PropsWithChildren} from 'react';
import ImageUI from 'ui/ImageUI';

interface IProps {
  isActive: boolean;
  onSelect: () => void;
}

export const SelectTimeBtn: FC<PropsWithChildren<IProps>> = ({onSelect, children, isActive}) => {
  return (
    <Button
      p="14px 12px"
      w="100%"
      fontSize={['14px', '16px']}
      bg={colors.white}
      _focus={{border: 'none'}}
      onClick={onSelect}
    >
      <Flex w="100%" alignItems="center" justifyContent="space-between">
        <Text fontWeight={isActive ? 'bold' : '500'}>{children}</Text>
        {isActive && <ImageUI w="24px" src="/icons/preorder-check-icon.svg" alt="check" />}
      </Flex>
    </Button>
  );
};
